import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModalConfig, NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { AttendanceService } from '../../../../../core/services/attendance.service';
import { ClassroomService } from '../../../../../core/services/classroom.service';
import { AppErrorShow } from '../../../../../core/utils/app-error-show';
import { AppSweetAlert } from '../../../../../core/utils/app-sweet-alert';
import { GlobalName } from '../../../../../core/utils/global-name';
import { LocalStorageService } from '../../../../../core/utils/local-stoarge-service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgSelectModule, NgLabelTemplateDirective, NgOptionTemplateDirective, NgSelectComponent } from '@ng-select/ng-select';
import { NgxPaginationModule } from 'ngx-pagination';
import { SampleSearchPipe } from '../../../../../core/pipes/sample-search.pipe';
import { LoadingComponent } from '../../../../components/loading/loading.component';
import { HeaderComponent } from '../../../layout/includes/header/header.component';

@Component({
    selector: 'app-student-attendance',
    templateUrl: './student-attendance.component.html',
    imports: [CommonModule, FormsModule, NgbModule, LoadingComponent, SampleSearchPipe, HeaderComponent, NgSelectModule,
        NgxPaginationModule,
        NgLabelTemplateDirective,
        NgOptionTemplateDirective,
        NgSelectComponent,
    ],
    styleUrls: ['./student-attendance.component.css']
})
export class StudentAttendanceComponent {
  buttonsPermission :any|undefined;
  search_text=""
  levelsFiltered:any[] =[]
  levels:any[] =[]
  cycles:any[] =[]
  data:any[] =[]
  classrooms:any[] =[]
  attendance_categories:any[] =[]
  selected_data:any;
  modalOption:any; 
  isDtInitialized:boolean = false
  is_active=null
  cycleId:any
  loading=false
  tag="admin-student-attendances"
  pg={
    pageSize:10,
    p:0,
    total:0
  }
  role:any
  user:any
  ayId:any;
   classroomId:any;

  constructor(
    private classroomService:ClassroomService,
    private attendanceService:AttendanceService,
    private toastrService:ToastrService,
      config: NgbModalConfig,
      private router:Router,
      private lsService:LocalStorageService,
    private modalService: NgbModal) {
     config.backdrop = 'static';
     config.keyboard = false;
     }


  ngOnInit(): void {
    this.user=this.lsService.get(GlobalName.userName)
       this.role=this.user.roles[0].name.toLowerCase()
    this.init()
    this.getActions()
  }

  init(){
    this.attendance_categories=this.lsService.get(GlobalName.features).attendance_categories
    this.getClassrooms()
   // this.getAll()
  
  }

  loadLevels(event:any){
    this.levelsFiltered= this.levels.filter((el:any)=>el.cycle_id == event?.target.value)
  }

  getAll(){
    this.attendanceService.getByStudents(this.classroomId).subscribe((res:any)=>{
      this.data=res.data
      this.pg.pageSize=10
      this.pg.p=0
      this.pg.total=res.data.length
      this.modalService.dismissAll()
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des propriétaires",err)
    })
  }

  getClassrooms(){
    this.classroomService.getAll().subscribe((res:any)=>{
      this.classrooms=res.data
    },
    (err:any)=>{
AppErrorShow.showError("Gestion des propriétaires",err)
    })
  }

  loadData1(event:any){
    this.ayId=event
    this.getAll()
   }
   loadData2(event:any){
    this.classroomId=event
    this.getAll()
   }


  store(value:any){
    this.loading=true
    
    this.attendanceService.store(value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()

    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des présences apprenants",err)

    })
  }
  update(value:any){
    this.loading=true

    this.attendanceService.update(this.selected_data.id,value).subscribe((res:any)=>{
      this.loading=false

        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      this.loading=false

      console.log(err)
        AppErrorShow.showError("Gestion des présences apprenants",err)

    })
  }
  delete(){
    if(!this.verifyIfElementChecked()) return ;
    let confirmed=AppSweetAlert.confirmBox('info','Suppression','Voulez vous vraiment retirer cet élément?',);
    confirmed.then((result:any)=>{
       if (result.isConfirmed) {
    this.attendanceService.delete(this.selected_data.id).subscribe((res:any)=>{
        this.toastrService.success(res.message)
        this.getAll()
    },
    (err:any)=>{
      console.log(err)
        AppErrorShow.showError("Gestion des présences apprenants",err)

    })
  }
})
  }
  checked(el?:any){
    this.selected_data=el;
    this.is_active=el.is_active
    this.cycleId=this.levels.find((el:any)=>el.id == this.selected_data.level_id)?.cycle_id
    this.levelsFiltered= this.levels.filter((el:any)=>el.cycle_id == this.cycleId)

  }
  verifyIfElementChecked(){
    console.log(this.selected_data)
    if (this.selected_data==null) {
      this.toastrService.warning("Aucun élément selectionné");
      return false;
    }
    return true;
  }



  dismiss(){
    this.modalService.dismissAll()
  }

  add(content:any){
    this.modalService.open(content,{size:'lg'});
  }


  show(){
    if(!this.verifyIfElementChecked()) return ;
    this.router.navigate(['/admin/bvs-attendances-details/'+this.selected_data.code])
  }

  edit(content:any){
    if(!this.verifyIfElementChecked()) return ;
    this.modalService.open(content,{size:'lg'});

  }

  setStatus(value:any){

    this.toastrService.warning("Opération en cours")
  
        this.attendanceService.setState(this.selected_data.id,value).subscribe((res:any)=>{
          this.toastrService.success(res.message)
          this.getAll()
      },
      (err:any)=>{
        console.log(err)
          AppErrorShow.showError("Gestion des présences apprenants",err)

      })
  }

  getPage(event:any){
    this.pg.p=event
  }

  getActions(){
    // this.buttonsPermission = {
    //   show:AppActionCheck.check(this.tag,'Consultation'),
    //   add:AppActionCheck.check(this.tag,'ajout'),
    //   edit:AppActionCheck.check(this.tag,'edition'),
    //   delete:AppActionCheck.check(this.tag,'suppression'),
    //   status:AppActionCheck.check(this.tag,'statut')
    // };
    this.buttonsPermission={
      show:true,
      add:false,
      edit:false,
      delete:true,
      status:true,
    }
  }
}
